<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <!-- Page Header -->
      <div class="page-header">
        <div class="page-title">
          <h4>Mon Profile</h4>
          <h6>Gérez vos informations personnelles et paramètres</h6>
        </div>
      </div>

      <!-- Profile Header Card -->
      <div class="card">
        <div class="card-body">
          <div class="profile-set">
            <div class="profile-head"></div>
            <div class="profile-top">
              <div class="profile-content">
                <div class="profile-contentimg">
                  <img :src="profileImageUrl || defaultAvatarUrl" alt="img" id="blah" class="profile-img-circle" />
                  <div class="profileupload">
                    <input type="file" id="imgInp" ref="fileInput" @change="handleImageSelect"
                      accept="image/jpeg,image/png,image/jpg,image/gif" style="display: none" />
                    <div>
                      <a href="javascript:void(0);" @click="triggerImageUpload" style="left: 33px;">
                        <img :src="editIconUrl" alt="img" />
                      </a>
                      <a href="javascript:void(0);" @click="deleteProfileImage" v-if="profileImageUrl"
                        title="Supprimer l'image">
                        <img :src="deleteIconUrl" alt="delete" />
                      </a>
                    </div>
                  </div>
                  <div v-if="imageUploading" class="upload-spinner">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </div>
                <div class="profile-contentname pt-3">
                  <h2>{{ this.currentUser?.nom_utilisateur }}</h2>
                  <h4>{{ this.currentUser?.email }}</h4>
                  <span :class="form.emailVerified ? 'badges-success' : 'badges-warning'">
                    {{ form.emailVerified ? "Email Vérifié" : "Email Non Vérifié" }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Personal Information Card -->
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-header-custom">
                <div class="card-icon">
                  <i data-feather="user"></i>
                </div>
                <div class="card-header-text">
                  <h5>Informations Personnelles</h5>
                  <p>Mettez à jour vos informations personnelles</p>
                </div>
              </div>

              <form @submit.prevent="submitForm">
                <div class="input-blocks">
                  <label class="form-label">Nom d'utilisateur</label>
                  <input type="text" class="form-control" v-model="form.nom" placeholder="Entrez votre nom" />
                </div>
                <div class="input-blocks">
                  <label class="form-label">Adresse Email</label>
                  <input type="email" class="form-control" v-model="form.email" placeholder="votre@email.com" />
                </div>
                <button type="submit" class="btn btn-submit me-2">
                  Enregistrer les modifications
                </button>
              </form>
            </div>
          </div>
        </div>

        <!-- Email Verification Card -->
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-header-custom">
                <div class="card-icon">
                  <i data-feather="mail"></i>
                </div>
                <div class="card-header-text">
                  <h5>Vérification Email</h5>
                  <p>Confirmez votre adresse email</p>
                </div>
              </div>

              <form @submit.prevent="submitForm2">
                <div class="status-toggle-group mb-3">
                  <div class="status-toggle-content">
                    <div class="status-icon-wrapper" :class="form.emailVerified ? 'verified' : 'unverified'">
                      <i :data-feather="form.emailVerified ? 'check-circle' : 'alert-circle'"></i>
                    </div>
                    <div class="status-text">
                      <h6>{{ form.emailVerified ? "Email Vérifié" : "Email Non Vérifié" }}</h6>
                      <span>{{ form2.email }}</span>
                    </div>
                  </div>
                </div>

                <button type="submit" class="btn btn-submit me-2" :disabled="form.emailVerified">
                  Envoyer l'email de vérification
                </button>
              </form>
            </div>
          </div>
        </div>

        <!-- Password Change Card -->
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="card-header-custom">
                <div class="card-icon">
                  <i data-feather="lock"></i>
                </div>
                <div class="card-header-text">
                  <h5>Sécurité</h5>
                  <p>Modifiez votre mot de passe</p>
                </div>
              </div>

              <form @submit.prevent="submitForm1">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-blocks">
                      <label class="form-label">Ancien Mot de passe</label>
                      <div class="pass-group">
                        <input type="password" class="pass-input form-control" v-model="form1.oldpassword"
                          placeholder="Entrez l'ancien mot de passe" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-blocks">
                      <label class="form-label">Nouveau Mot de passe</label>
                      <div class="pass-group">
                        <input type="password" class="pass-input form-control" v-model="form1.password"
                          placeholder="Entrez le nouveau mot de passe" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-blocks">
                      <label class="form-label">Confirmer le mot de passe</label>
                      <div class="pass-group">
                        <input type="password" class="pass-input form-control" v-model="form1.confirmPassword"
                          placeholder="Confirmez le nouveau mot de passe" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <button type="submit" class="btn btn-submit me-2">
                      Modifier le mot de passe
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentUser } from "@/services/authService";
import { getEmployeesData } from "@/services/emplooyesService";
import {
  updateUser,
  resetUserPassword,
  verifyEmail,
  uploadProfileImage,
  deleteProfileImage as deleteProfileImageService,
} from "@/services/userService";
import { toast } from "vue3-toastify";
import Swal from "sweetalert2";
import feather from "feather-icons";

export default {
  data() {
    return {
      form: {
        nom: "",
        email: "",
        role_id: "",
        emailVerified: false,
      },
      form1: {
        oldpassword: "",
        password: "",
        confirmPassword: "",
      },
      form2: {
        email: "",
      },
      currentUser: null,
      profileImageUrl: null,
      imageUploading: false,
      defaultAvatarUrl: require("@/assets/img/customer/avatar.png"),
      editIconUrl: require("@/assets/img/icons/edit-set.svg"),
      deleteIconUrl: require("@/assets/img/icons/delete.svg"),
    };
  },
  methods: {
    normalizeImageUrl(path) {
      if (!path) return null;
      if (/^https?:\/\//i.test(path)) return path;
      const baseUrl = process.env.VUE_APP_URL || window.location.origin;
      const sanitizedBase = baseUrl.endsWith("/")
        ? baseUrl.slice(0, -1)
        : baseUrl;
      const sanitizedPath = path.startsWith("/")
        ? path
        : `/${path}`;
      return `${sanitizedBase}${sanitizedPath}`;
    },
    emitProfileImageUpdate(imageUrl, profileImagePath = null) {
      window.dispatchEvent(
        new CustomEvent("profile-image-updated", {
          detail: {
            imageUrl: imageUrl || null,
            profileImagePath: profileImagePath || null,
          },
        })
      );
    },
    async submitForm() {
      try {
        const response = await updateUser(this.currentUser.user_id, {
          name: this.form.nom,
          email: this.form.email,
        });
        localStorage.setItem("access_token", response.token);
        this.currentUser = getCurrentUser();
        window.dispatchEvent(new CustomEvent("profile-updated"));
        Swal.fire({
          icon: "success",
          title: "Modifié!",
          text: "Votre profile a été modifié.",
          confirmButtonClass: "btn btn-success",
        });
      } catch (error) {
        console.error(error);
        const message =
          error?.response?.data?.message ||
          "Erreur lors de l'envoi des données";
        toast.error(message);
        if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        }
      }
    },

    async submitForm1() {
      if (this.form1.password !== this.form1.confirmPassword) {
        toast.error("Erreur ! Confirmer le mot de passe");
      } else {
        try {
          await resetUserPassword(this.currentUser.user_id, {
            current_password: this.form1.oldpassword,
            password: this.form1.password,
          });
          Swal.fire({
            icon: "success",
            title: "Modifié!",
            text: "Votre mot de passe a été modifié.",
            confirmButtonClass: "btn btn-success",
          });
          this.form1.oldpassword = "";
          this.form1.password = "";
          this.form1.confirmPassword = "";
        } catch (error) {
          console.error(error);
          const message =
            error?.response?.data?.message ||
            "Erreur lors de l'envoi des données";
          const message1 =
            error?.response?.data?.error ||
            "Erreur lors de l'envoi des données";
          toast.error(message);
          toast.error(message1);
        }
      }
    },

    async submitForm2() {
      try {
        await verifyEmail();
        Swal.fire({
          icon: "success",
          title: "Email Envoyé!",
          text: "Un email de vérification a été envoyé vers votre boîte",
          confirmButtonClass: "btn btn-success",
        });
      } catch (error) {
        console.error(error);
        const message =
          error?.response?.data?.message ||
          "Erreur lors de l'envoi des données";
        const message1 =
          error?.response?.data?.error || "Erreur lors de l'envoi des données";
        toast.error(message);
        toast.error(message1);
      }
    },

    triggerImageUpload() {
      this.$refs.fileInput?.click();
    },

    async handleImageSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/gif",
      ];
      if (!allowedTypes.includes(file.type)) {
        toast.error(
          "Format de fichier non supporté. Utilisez JPEG, PNG, JPG ou GIF."
        );
        return;
      }

      const maxSize = 2 * 1024 * 1024;
      if (file.size > maxSize) {
        toast.error("La taille du fichier ne peut pas dépasser 2MB.");
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.profileImageUrl = e.target.result;
      };
      reader.readAsDataURL(file);

      await this.uploadImage(file);
    },

    async uploadImage(file) {
      this.imageUploading = true;
      try {
        const formData = new FormData();
        formData.append("profile_image", file);

        const response = await uploadProfileImage(formData);
        const payload = response?.data || {};
        const imageUrl =
          this.normalizeImageUrl(
            payload.image_url || (payload.profile_image ? `/storage/${payload.profile_image}` : "")
          ) || this.profileImageUrl;

        this.profileImageUrl = imageUrl;

        toast.success("Image de profil mise à jour avec succès!");

        this.emitProfileImageUpdate(imageUrl, payload.profile_image);
      } catch (error) {
        console.error(error);
        const message =
          error?.response?.data?.message ||
          "Erreur lors du téléchargement de l'image";
        toast.error(message);

        this.profileImageUrl = null;
        this.emitProfileImageUpdate(null);
      } finally {
        this.imageUploading = false;
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
      }
    },

    async deleteProfileImage() {
      try {
        const result = await Swal.fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous supprimer votre image de profil?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Oui, supprimer!",
          cancelButtonText: "Annuler",
        });

        if (result.isConfirmed) {
          await deleteProfileImageService();

          this.profileImageUrl = null;
          this.emitProfileImageUpdate(null);

          toast.success("Image de profil supprimée avec succès!");
        }
      } catch (error) {
        console.error(error);
        const message =
          error?.response?.data?.message ||
          "Erreur lors de la suppression de l'image";
        toast.error(message);
      }
    },

    async loadUserProfileImage() {
      try {
        const users = await getEmployeesData();
        const user = users.find((user) => user.id === this.currentUser.user_id);

        if (user && user.profile_image) {
          this.profileImageUrl = this.normalizeImageUrl(
            `/storage/${user.profile_image}`
          );
        } else {
          this.profileImageUrl = null;
        }
        this.emitProfileImageUpdate(this.profileImageUrl, user?.profile_image);
      } catch (error) {
        console.error("Error loading profile image:", error);
        this.profileImageUrl = null;
        this.emitProfileImageUpdate(null);
      }
    },
  },

  async mounted() {
    this.currentUser = getCurrentUser();
    const users = await getEmployeesData();
    const user = users.filter((user) => user.id === this.currentUser.user_id);
    this.form.nom = this.currentUser?.nom_utilisateur;
    this.form.email = this.currentUser?.email;
    this.form.emailVerified = user[0].email_verified_at === null ? false : true;
    this.form.role_id = this.currentUser?.role_id;
    this.form2.email = this.currentUser?.email;

    await this.loadUserProfileImage();

    // Initialize Feather Icons
    this.$nextTick(() => {
      feather.replace();
    });
  },

  updated() {
    // Re-initialize Feather Icons after updates
    this.$nextTick(() => {
      feather.replace();
    });
  },
};
</script>

<style scoped>
/* Custom Card Header */
.card-header-custom {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.card-icon {
  width: 45px;
  height: 45px;
  background: #f8f9fa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-icon svg {
  width: 22px;
  height: 22px;
  color: #ff9f43;
}

.card-header-text h5 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 3px;
  color: #1b2850;
}

.card-header-text p {
  font-size: 13px;
  color: #8b909a;
  margin-bottom: 0;
}

/* Status Toggle Group */
.status-toggle-group {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
}

.status-toggle-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.status-icon-wrapper {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.status-icon-wrapper.verified {
  background: #d4edda;
}

.status-icon-wrapper.verified svg {
  color: #28a745;
  width: 24px;
  height: 24px;
}

.status-icon-wrapper.unverified {
  background: #fff3cd;
}

.status-icon-wrapper.unverified svg {
  color: #ffc107;
  width: 24px;
  height: 24px;
}

.status-text h6 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 3px;
  color: #1b2850;
}

.status-text span {
  font-size: 13px;
  color: #8b909a;
}

/* Profile Content Enhancements */
.profile-contentname {
  text-align: center;
}

.profile-contentname h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 5px;
}

.profile-contentname h4 {
  font-size: 14px;
  color: #8b909a;
  font-weight: 400;
  margin-bottom: 10px;
}

.badges-success {
  display: inline-block;
  padding: 5px 15px;
  background: #d4edda;
  color: #28a745;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}
.profile-set .profile-top .profileupload a {
    display: flex
;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    background: #FF9F43;
    width: 34px;
    height: 34px;
    z-index: 1;
    border-radius: 50px;
    position: absolute;
    bottom: -22px;
    left: 72px;
}
.badges-warning {
  display: inline-block;
  padding: 5px 15px;
  background: #fff3cd;
  color: #ffc107;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

/* Upload Spinner */
.upload-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Profile Image Styling */
.profile-contentimg {
  position: relative;
  display: inline-block;
}

.profile-img-circle {
  width: 150px !important;
  height: 110px !important;
  object-fit: cover !important;
  border-radius: 50% !important;
  border: 4px solid #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  display: block !important;
}

.profileupload {
  display: flex;
  align-items: center;
  gap: 5px;
}

.profileupload a img {
  width: 30px;
  height: 30px;
  transition: transform 0.2s;
}

.profileupload a:hover img {
  transform: scale(1.1);
}

/* Form Enhancements */
.input-blocks {
  margin-bottom: 20px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #1b2850;
  margin-bottom: 8px;
}

.form-control {
  font-size: 14px;
  padding: 10px 15px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.form-control:focus {
  border-color: #ff9f43;
  box-shadow: 0 0 0 0.2rem rgba(255, 159, 67, 0.1);
}

/* Button Styling */
.btn-submit {
  padding: 10px 25px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Card Spacing */
.card {
  margin-bottom: 24px;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
}

.card-body {
  padding: 25px;
}

/* Responsive */
@media (max-width: 768px) {
  .card-header-custom {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }

  .status-toggle-content {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
}
</style>
